module.exports = __webpack_public_path__ + "img/screenshot-step2.a2f96912.png";